import { cn } from "@hulahoop/ui";
import type { HTMLAttributes, ReactNode } from "react";

interface FullScreenCenterProps extends HTMLAttributes<HTMLElement> {
  as?: "main" | "div";
  children: ReactNode;
}

export function FullScreenCenter({
  as: Element = "div",
  className,
  children,
  ...props
}: FullScreenCenterProps) {
  return (
    <Element
      {...props}
      className={cn(
        "min-h-screen flex items-center justify-center bg-background text-foreground",
        className,
      )}
    >
      {children}
    </Element>
  );
}
